// extracted by mini-css-extract-plugin
module.exports = {"image":"responsiveImage_image__nK34c","picture":"responsiveImage_picture__esBjK"};